import { render, staticRenderFns } from "./order-serve-management.vue?vue&type=template&id=8a9d4d5e&scoped=true&"
import script from "./order-serve-management.vue?vue&type=script&lang=js&"
export * from "./order-serve-management.vue?vue&type=script&lang=js&"
import style0 from "./order-serve-management.vue?vue&type=style&index=0&id=8a9d4d5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a9d4d5e",
  null
  
)

export default component.exports